module.exports = __webpack_public_path__ + "media/seher_1.0a.a1a2f143.mp3";